import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const PhoneCall = forwardRef<SVGSVGElement, SvgIconProps>(
  function PhoneCall(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M6.73 5.568c.559 0 1.094.206 1.51.582l.825.746c.446.403.708.956.738 1.556.03.6-.175 1.177-.579 1.623l-.489.54a2.244 2.244 0 01-1.019.646l-.149.045.07.14a9.48 9.48 0 005.01 4.597l.128.05.044-.13c.099-.294.255-.56.464-.79l.49-.542a2.247 2.247 0 013.178-.16l.826.748c.92.831.992 2.257.16 3.178l-.49.541a2.276 2.276 0 01-.55.443c-.52.32-1.205.47-1.934.404-5.556-.498-10.17-4.671-11.222-10.149-.227-1.177.166-2.138.628-2.534l.022-.024c.057-.083.117-.158.18-.227l.49-.542a2.255 2.255 0 011.67-.74zm5.192.6a5.241 5.241 0 015.236 5.234.525.525 0 01-1.05 0 4.191 4.191 0 00-4.186-4.186.525.525 0 010-1.049zm.085-2.568c4.256 0 7.718 3.462 7.718 7.718a.525.525 0 01-1.05 0 6.676 6.676 0 00-6.668-6.669.525.525 0 010-1.049z" />
      </SvgIcon>
    )
  },
)

export default PhoneCall
